import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export const createTwitterTweetButton = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): TwitterTweetButtonInterface => {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.TwitterTweetButton,
      parentId,
      masterBlockId,
    ),
    text: '',
    alignSelf: 'center',
  }
}
